"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (input, usernames) => {
    usernames.forEach((username) => {
        const regex = new RegExp('@' + username, 'g');
        input = input.replace(regex, '@' + username + '|=');
    });
    return input;
};
